import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.444 5a1 1 0 01.907.543l6.538 12.718c.099.191.13.4.101.598A1 1 0 0121 20H2.5a1 1 0 01-.855-1.519l5.462-9a1 1 0 011.557-.193l2.151 2.124 2.741-5.837A1 1 0 0114.444 5zm1.92 6.889L19.506 18H4.276l3.884-6.399 1.753 1.731-.818 1.743a1 1 0 001.81.85l1.382-2.942a3 3 0 003.008-.312l1.07-.782zm-.925-1.801l-.937-1.822-1.365 2.906a1 1 0 00.977-.115l1.325-.97z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
